import {Perspective} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/layout/Perspective';
import {
    GlassLayer,
    PanelSet,
    Section,
    SectionRun
} from '@mintdata-wsp/common/state/ui/visualDesigner/workbench/PanelState';
import {ResizeEvent} from '@mintdata-wsp/wsp/ui/components/resizable/Resizer';
import {OnPanelResize} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import {SectionRunView} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/SectionRunView';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./RootLayoutView.less');
const cx = classnames.bind(styles);

export interface RootLayoutViewProps
{
    className?:string;
    perspective:Perspective;
}

@observer
export class RootLayoutView extends React.Component<RootLayoutViewProps, any>
{
    private _listeners:OnPanelResize[] = [];

    @bind
    private _onAddResizeListener(listener:OnPanelResize):void
    {
        this._listeners.push(listener);
    }

    @bind
    private _notifyPanels(e:ResizeEvent):void
    {
        for( let listener of this._listeners )
            listener(e);
    }

    @bind
    private _onSectionResized(run:SectionRun,
                              section:Section,
                              isVertical:boolean,
                              sectionBeforeResizer,
                              sectionAfterResizer):any
    {
        return action((resizeEvent:ResizeEvent) =>
        {
            const sectionInfo = this._getSectionToResize(run, section);
            if( !sectionInfo )
                return;

            const delta = isVertical ? resizeEvent.deltaX : resizeEvent.deltaY;

            if( sectionInfo.isAdjacent )
                sectionInfo.section.runSpec.value -= delta;
            else
                sectionInfo.section.runSpec.value += delta;

            this._notifyPanels(resizeEvent);
        });
    }

    @bind
    private _getSectionToResize(run:SectionRun, section:Section):{section:Section, isAdjacent:boolean} | null
    {
        if( section.runSpec.isFixedPixels )
            return {section: section, isAdjacent: false};
        else
        {
            const sections = run.sections;
            const sectionIdx = sections.findIndex((s:Section) => (s.id === section.id));

            const nextSectionIdx = sectionIdx + 1;
            if( nextSectionIdx < sections.length )
                return {section: sections[nextSectionIdx], isAdjacent: true};
        }

        return null;
    }

    private _appendGlassLayers(panelSet:PanelSet, elements:React.ReactElement<any>[])
    {
        if( panelSet.glassLayers )
        {
            panelSet.glassLayers.map((glass:GlassLayer) =>
            {
                const props = Object.assign({}, glass.element.props, {key: glass.id});
                const clonedElem = React.cloneElement(glass.element, props);

                elements.push(clonedElem);
            });
        }
    }

    render()
    {
        const {perspective, className} = this.props;

        if( !perspective )
            return null;

        const panelSet = perspective.panelSet;
        const rootRun = panelSet.rootRun;

        const elements = [
            <SectionRunView key={rootRun.id}
                            run={rootRun}
                            onPanelResize={this._onAddResizeListener}
                            onSectionResized={this._onSectionResized}
            />
        ];

        this._appendGlassLayers(panelSet, elements);

        return (
            <div className={cx('rootLayoutView', className)}>
                {elements}
            </div>
        );
    }
}







